module.exports = __webpack_public_path__ + "img/person-tablets.fadfbeeb.jpg";